import { Component, OnInit, Input, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { MemberofficeService } from '@app/services/memberoffices/memberoffice.service';
import { Subscription } from 'rxjs';
import { MemberOffice } from '@app/models/memberoffice';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { SnackbarService } from '@app/services/shared/snackbar.service';
import { PermissionsService } from '@app/services/permissions/permissions.service';
import { AuthService } from '@app/services/auth/auth.service';
import { DatePipe } from '@angular/common';
import { MemberService } from '@app/services/member.service';
import { ConfirmationService } from 'primeng/api';

interface Office {
  memberOfficeId: number;
  memberId: number;
  institutionId: number;
  officeCommitteeId: number;
  action: string;
  fromDate: Date;
  toDate: Date;
}

@Component({
  selector: 'app-memberoffices',
  templateUrl: './memberoffices.component.html',
  styleUrls: ['./memberoffices.component.css']

})
export class MemberofficesComponent implements OnInit, OnDestroy, OnChanges {
  // @Input() memberid;
  @Input() roleid;
  @Input() showall: boolean;
  @Input() baseinfo: any;

  memberoffices: MemberOffice[] = [];
  currentDate = new Date();
  mobiledevice = false;
  permissions: string[] = [];
  edit = false;
  editmemberoffice;
  editform;
  
  institutionaccess;
  minmaxyear = { minYear: '1920', maxYear: '2099' };
  autoCorrectedDatePipe = createAutoCorrectedDatePipe('yyyy-mm-dd', this.minmaxyear);
  public mask = [/[1-9]/, /\d/, /\d/, ' ', /\d/, /\d/]; // zipcode
  public maskdatum = [/[129]/, /[?09]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
  subscriptions: Subscription[] = [];
  memberid;
  can_edit_member_offices;

  constructor(
    private activatedRoute: ActivatedRoute,
    private memberofficesService: MemberofficeService,
    private memberService: MemberService,
    private datePipe: DatePipe,
    private authService: AuthService,
    private router: Router,
    private fb: FormBuilder,
    private snackbarService: SnackbarService,
    private permissionsService: PermissionsService,
    private confirmationService: ConfirmationService) {
    this.subscriptions.push(this.permissionsService.permissions.subscribe(response => {
      if (response) {
        this.permissions = response;
      }
    }));
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.memberid) {
      this.getMemberOffices();
    }
    if (changes) {
      if (changes.roleid) {
        this.roleid = Number(changes.roleid.currentValue);
      }
      this.permissionsService.setInstitutionAccess();
      this.permissionsService.institutionaccess.subscribe(a => {
        if (a) {
          this.institutionaccess = a;
        }
      });
    }
  }

  getMemberPrimaryInstitution(memberid: number) {
    this.memberService.getMemberPrimaryInstitution(memberid).subscribe(inst => {
      this.permissionsService.memberlodge = inst.id;
      this.permissionsService.setMemberAccess();
      this.permissionsService.setInstitutionAccess();
    });
  }

  ngOnInit() {
    this.editform = this.fb.group({
      id: ['', ''],
      institutionId: ['', ''],
      institutionShortName: ['', ''],
      institutionName: ['', ''],
      fromDate: ['', ''],
      toDate: ['', ''],
      officeCommitteeId: ['', ''],
      officeName: ['', '']
    });
    
    this.authService.isMobileDevice.subscribe(mobile => {
      this.mobiledevice = mobile;
    });

    this.memberService.timestamp.subscribe(_ => {
      if (this.memberid && this.roleid) {
        this.getMemberOffices();
      }
    });
    this.activatedRoute.paramMap.subscribe(paramMap => {
      this.memberid = +paramMap.get('id');
      if (this.memberid) {
        this.edit = false;
        this.getMemberOffices();
      }
    });
    this.permissionsService.selectedrole.subscribe(r => {
      if (r) {
      this.setPermissions();
      }
    })
  }

  setPermissions() {
    /*this.permissionsService.hasPermissionForMember('EDIT_MEMBER_OFFICES', this.memberid).subscribe(resp => {
      this.can_edit_member_offices = resp;
    });*/
       const user_permissions = JSON.parse(sessionStorage.getItem('selectedrole')).permissions;
    this.can_edit_member_offices = user_permissions.indexOf('EDIT_MEMBER_OFFICES') !== -1;
  }

  getMemberOffices() {
    this.subscriptions.push(this.memberofficesService.GetMemberOfficesByMemberIdAsync(this.roleid, this.memberid).subscribe(data => {
      this.memberoffices = data;
     // this.setPermissions();
    }));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
  }

  removeOffice(office: any) {
    const officedata = [{
      memberOfficeId: office.id,
      memberId: this.memberid,
      institutionId: office.institutionId,
      officeCommitteeId: office.officeCommitteeId,
      action: 'delete'
    }];

    this.subscriptions.push(this.memberofficesService.UpdateMemberOffice(officedata).subscribe(response => {
      if (response) {
        if (response[0].status === 'ok') {
          this.getMemberOffices();
          this.snackbarService.openSnackBar('Uppdraget/ämbetet borttaget', null);
        } else {
          this.snackbarService.openSnackBar(response[0].status, null);
        }
      }
      this.getMemberOffices();
    }));
  }

  confirmRemoveOffice(office: any) {
     this.confirmationService.confirm({
      header: 'Bekräfta radering',
      message: 'Vill du radera valt uppdrag/ämbete?',
      acceptLabel: 'Ja',
      rejectLabel: 'Nej',
      accept: () => {
        this.removeOffice(office);
      },
      reject: () => {
      }
    });
  }

  editOffice(office: any) {
    office.fromDate = this.datePipe.transform(office.fromDate, 'yyyy-MM-dd');
    office.toDate = this.datePipe.transform(office.toDate, 'yyyy-MM-dd');
    this.editmemberoffice = office;
    this.editform.patchValue(this.editmemberoffice);
    this.edit = true;
  }

  addOffice() {
    if (this.institutionaccess.admininstitutionid) {
      this.router.navigate(['uppdrag'], { queryParams: { institutionid: this.institutionaccess.admininstitutionid, memberid: this.memberid, type: 'member' }, queryParamsHandling: "merge" });
    } else {
      // this.router.navigateByUrl('/uppdrag/memberid/' + this.memberid);
      this.router.navigate(['uppdrag'], { queryParams: { memberid: this.memberid, type: 'member' }, queryParamsHandling: "merge" });
    }
  }

  officeAdded(event) {
    if (event === 'officeAdded') {
      this.getMemberOffices();
    } else if (event === 'cancelAddOffice') {
    }
  }

  saveOffice(office: any) {
    const preparedOffice: Office = {
      memberOfficeId: office.id,
      memberId: this.memberid,
      institutionId: office.institutionId,
      officeCommitteeId: office.officeCommitteeId,
      action: 'update',
      fromDate: new Date(this.editform.get('fromDate').value),
      toDate: new Date(this.editform.get('toDate').value)
    };

    const _office: Office[] = [];
    _office.push(preparedOffice);

    this.subscriptions.push(this.memberofficesService.UpdateMemberOffice(_office).subscribe(response => {
      if (response) {
        if (response[0].rowsAffected !== 0) {
          this.getMemberOffices();
          this.snackbarService.openSnackBar('Uppdraget/ämbetet uppdaterat.', null);
        } else {
          this.confirmationService.confirm({
          header: 'Information',
          message: response[0].status,
          acceptLabel: 'Ok',
          rejectVisible: false,
          accept: () => {
        }
        });
        }
      }
    }));
    this.edit = false;
  }

  cancelOffice() {
    this.edit = false;
  }
}
